if (document.querySelector(".users")) {
    //
}
